import { Component, Input } from '@angular/core';
import { CurrentDeviceService } from '@app/shared/services/current-device.service';

@Component({selector: 'app-auth-header',
  templateUrl: './auth-header.component.html',
  standalone: false,
})
export class AuthHeaderComponent {
  @Input()
  title: string;

  @Input()
  subtitle: string;

  constructor(public currentDeviceService: CurrentDeviceService) {}
}
